/* Code generated with AutoHTML Plugin for Figma */
import { useEffect, useState } from "react";
import { createFirstDiscontAPI } from "../../api/discontAPI";
import DiscontSvg from "../../assets/icons/discont.svg?react";
import { Link } from "../../components/link/link";
import { Text } from "../../components/texts/text";
import { _colorText, _size, _sizeText, _style } from "../../core/core";
import "./PersonDiscont.css";
interface DiscontNewUserProps {
  email: string;
  header?: boolean;
  [key: string]: any;
}

export const DiscontNewUser: React.FC<DiscontNewUserProps> = ({
  email,
  header = false,
  ...props
}) => {
  const [isActive, setIsActive] = useState(false);

  const fetchDiscontFirst = async () => {
    try {
      const response = await createFirstDiscontAPI(email); // Замените '/api/service-previews' на ваше API-оконечное точка для получения карточек услуг
      if (response.discont) setIsActive(true);
    } catch (error) {
      console.error("Ошибка при получении карточек услуг:", error);
    }
  };

  useEffect(() => {
    fetchDiscontFirst();
  }, []);
  return (
    <>
      {header ? (
        <>
          {isActive && (
            <div className="header-discont">
              <Text size={_sizeText.mbold} color={_colorText.black}>
                Дарим скидку 15% на первый заказ, доступна при оформление заказа
              </Text>
            </div>
          )}
        </>
      ) : (
        <>
          {isActive && (
            <div className="person-discontbody discont-new-user">
              <div className="person-discont-body-left  ">
                <DiscontSvg />
                <div className="person-discont-body-text discont-new-user">
                  <Text size={_sizeText.mbold} color={_colorText.black}>
                    Дарим скидку 15% на первый заказ, доступна при оформление
                    заказа
                  </Text>
                </div>
              </div>
              <Link
                isMobileWidth
                style={_style.primary}
                size={_size.M}
                link={"#fastpay"}
              >
                Перейти к заказу
              </Link>
            </div>
          )}
        </>
      )}
    </>
  );
};
